import { createContext, useState, useMemo } from "react";
import { createTheme } from "@mui/material/styles";

export const themeSettings = (mode) => {
    return {
        palette: {
            mode,
        },
    }
}

// context for color mode
export const ColorModeContext = createContext({
    toggleColorMode: () => {},
});

export const useMode = () => {
    // Initialize state from localStorage, defaulting to "dark"
    const [mode, setMode] = useState(() => {
        return localStorage.getItem("fs-color-mode") || "dark";
    });

    const colorMode = useMemo(
        () => ({
            toggleColorMode: () =>
                setMode((prev) => {
                    const nextMode = prev === "light" ? "dark" : "light";
                    localStorage.setItem("fs-color-mode", nextMode); // Save to storage
                    return nextMode;
                }),
        }),
        []
    );

    const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
    return [theme, colorMode];
};